import { Component, OnInit } from '@angular/core';
import { AppService } from 'src/app/app.service';
import { MatIconModule } from '@angular/material/icon';


@Component({
    selector: 'app-bottom-navigation',
    templateUrl: './bottom-navigation.component.html',
    styleUrls: ['./bottom-navigation.component.scss'],
    imports: [MatIconModule]
})
export class BottomNavigationComponent implements OnInit {
  pageIndex = 0;
  pages: string[] = [];

  constructor(private appService: AppService) {
    this.pages = this.appService.pages;
  }

  ngOnInit(): void {
    this.appService.getPageIndex().subscribe({
      next: (pageIndex: number) => {
        this.pageIndex = pageIndex;
      },
      error: (error) => {
        console.error('Error getting pageIndex:', error);
      }
    });
  }

  setPageIndex(pageIndex: number): void {
    this.appService.setPageIndex(pageIndex);
  }
}
